import { AxiosResponse } from "axios";
import { axiosInstance, MessageResponse } from "./common";

export interface CreditAccountProvisionDetails {
  account_number: string;
  as_of_date?: string | null;
  percentage?: number | null;
  amount?: number | null;
}

export interface UpsertCreditAccountProvisionRequest {
  as_of_date: string;
  percentage?: number | null;
  amount?: number | null;
}

export const CreditAccountProvisionsAPI = {
  upsert: async (
    case_id: string,
    account_number: string,
    request: UpsertCreditAccountProvisionRequest
  ) => {
    const response: AxiosResponse<MessageResponse> =
      await axiosInstance.put(
        `/v1/cases/${case_id}/credit-accounts/${account_number}/credit-account-provisions`,
        request
      );

    return response.data;
  },
};